import container from './CQRS';

const { queriesController, commandsController } = container;

async function getAvatarImagesBank() {
  try {
    return await queriesController.fethAvatarImagesBank();
  } catch (error) {
    throw new Error('[Service]: Oops!, The avatar list could not be obtained...');
  }
}

async function getAvatarByChild({ childId }) {
  try {
    return await queriesController.fetchAvatarBychild({ childId });
  } catch (error) {
    throw new Error('[Service]: Oops!, we cant get your avatar...');
  }
}

async function saveAvatarSelection({ childId, avatarId }) {
  try {
    return await commandsController.saveChildAvatarSelection({ childId, avatarId });
  } catch (error) {
    throw new Error('[Service]: Oops!, We cant save your avatar');
  }
}

async function getRankingAndLevelInformation(childId) {
  try {
    return await queriesController.fetchRankingAndLevelInformation({ childId });
  } catch (error) {
    throw new Error('[Service]: Oops!, Ranking and level information could not be obtained.');
  }
}

async function getCoinsInformation(childId) {
  try {
    return await queriesController.fetchCoinsInformation({ childId });
  } catch (error) {
    throw new Error(
      '[Service]: Oops!, We have not been able to obtain the information of the coins.',
    );
  }
}

async function getRewardsChild(childId) {
  try {
    return queriesController.fetchRewards({ childId });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to obtain the rewards child');
  }
}

async function setUpdateReward(rewardId, body) {
  try {
    return commandsController.updateReward({ rewardId, body });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to update the reward');
  }
}

async function setDeleteReward(rewardId) {
  try {
    return commandsController.deleteReward({ rewardId });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to delete the reward');
  }
}

async function setClaimReward(rewardId) {
  try {
    return commandsController.claimReward({ rewardId });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to claim the reward');
  }
}

async function setCreateReward(rewardData) {
  try {
    return commandsController.createReward({ rewardData });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to create the reward');
  }
}

async function getDefaultRewards() {
  try {
    return queriesController.fetchDefaultRewards();
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to load the default rewards');
  }
}

async function getChildLockedBadges({ childId }) {
  try {
    return await queriesController.fetchChildLockedBadges({ childId });
  } catch (error) {
    throw new Error("[Service]: Oops!, Unable to obtain child's locked badges.");
  }
}

async function getChildUnlockedBadges({ childId }) {
  try {
    return await queriesController.fetchChildUnlockedBadges({ childId });
  } catch (error) {
    throw new Error("[Service]: Oops!, Unable to obtain child's unlocked badges.");
  }
}

async function getQuestionsRate() {
  try {
    return await queriesController.fetchQuestionsRate();
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain rate questions.');
  }
}

async function setAnswersRate(answersData) {
  try {
    return await commandsController.sendAnswersRate({ answersData });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to send answers to rate .');
  }
}

async function getWeekAnswersRate(childId) {
  try {
    return await queriesController.fetchWeekAnswersRate({ childId });
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain rate answers.');
  }
}

async function getChildCoinsValues({ childId }) {
  try {
    const fetchChildCoinsValues = await queriesController.fetchChildCoinsValues({ childId });
    return fetchChildCoinsValues;
  } catch (error) {
    throw new Error('[Service]: Oops!, It is not possible to obtain the values of the coins..');
  }
}

async function updateCoinstValues({ childId, coinsToUpdate }) {
  try {
    const fetchChildCoinsValues = await commandsController.updateCoinstValues({
      childId,
      coinsToUpdate,
    });
    return fetchChildCoinsValues;
  } catch (error) {
    throw new Error('[Service]: Oops!, It is not possible to save the values of the coins..');
  }
}

async function getChildCoinsPending(childId) {
  try {
    const fetchChildCoinsPending = await queriesController.fetchChildCoinsPending({ childId });
    return fetchChildCoinsPending;
  } catch (error) {
    throw new Error("[Service]: Oops!, Unable to obtain child's coins pending.");
  }
}

async function acceptOrRejectCoins(itemId, valueApproved) {
  try {
    const dataApproved = {
      value: valueApproved,
    };
    const fetchChildCoinsPending = await commandsController.acceptOrRejectCoins({
      itemId,
      dataApproved,
    });
    return fetchChildCoinsPending;
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to accept or reject the coins.');
  }
}

export {
  getAvatarImagesBank,
  getRankingAndLevelInformation,
  getCoinsInformation,
  saveAvatarSelection,
  getAvatarByChild,
  getRewardsChild,
  setUpdateReward,
  setDeleteReward,
  setClaimReward,
  setCreateReward,
  getDefaultRewards,
  getChildLockedBadges,
  getChildUnlockedBadges,
  getQuestionsRate,
  setAnswersRate,
  getWeekAnswersRate,
  getChildCoinsValues,
  updateCoinstValues,
  getChildCoinsPending,
  acceptOrRejectCoins,
};
